import "../../CommonImports";
import "../../Core/core.css";
import "./List.css";
import "./ListDropIndicator.css";
import * as React from "react";
import { beginDragOperation, DragImage } from '../../Utilities/DragDrop';
import { cellFromEvent } from "./List";
/**
 * A behavior that turns a list into the source of a drag and drop operation. Note - this
 * behavior should only be used if your list is intended to _only_ be a drag source. Please use
 * the ListDragDropBehavior instead if the list is also a drop target, as that is the only way
 * to get keyboard drag and drop support within your list.
 */
var ListDragSourceBehavior = /** @class */ (function () {
    function ListDragSourceBehavior(options) {
        var _this = this;
        this.initialize = function (props, dragDroppableUI, eventDispatch) {
            _this.dragDroppableUI = dragDroppableUI;
            _this.eventDispatch = eventDispatch;
            _this.eventDispatch.addEventListener("mousedown", _this.onMouseDown);
            _this.eventDispatch.addEventListener("touchstart", _this.onTouchStart);
            _this.eventDispatch.addEventListener("dragstart", _this.onDragStart);
            _this.eventDispatch.addEventListener("dragend", _this.onDragEnd);
            _this.itemProvider = props.itemProvider;
        };
        this.onDragEnd = function (event) {
            var index = cellFromEvent(event).rowIndex;
            if (index >= 0 && _this.options.onDragEnd) {
                _this.options.onDragEnd(event);
            }
            _this.dragDroppableUI.removeOverlay("drag-source-item");
            _this.dragImageData = undefined;
        };
        this.onDragStart = function (event) {
            var index = cellFromEvent(event).rowIndex;
            if (index >= 0) {
                if (_this.options.onDragStart) {
                    _this.options.onDragStart(event);
                }
                if (event.detail.dataTransfer.effectAllowed !== "none" /* none */) {
                    _this.dragDroppableUI.addOverlay("drag-source-item", index, _this.renderDragSourceItemOverlay);
                    if (_this.dragImageData === undefined) {
                        _this.dragImageData = {
                            image: _this.options.renderDragImage(event)
                        };
                    }
                }
            }
        };
        this.onMouseDown = function (event) {
            if (event.button === 0) {
                _this.beginDrag(event);
            }
        };
        this.onTouchStart = function (event) {
            _this.beginDrag(event);
        };
        this.renderDragSourceItemOverlay = function (props) {
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "bolt-list-drag-source-item flex-grow" }),
                _this.operation && _this.dragImageData && React.createElement(DragImage, { operation: _this.operation }, _this.dragImageData.image)));
        };
        this.setDragImage = function (image, xOffset, yOffset) {
            _this.dragImageData = { image: image, xOffset: xOffset, yOffset: yOffset };
        };
        this.options = options;
    }
    ListDragSourceBehavior.prototype.componentDidUpdate = function (props) {
        this.itemProvider = props.itemProvider;
    };
    ListDragSourceBehavior.prototype.componentWillUnmount = function () {
        this.eventDispatch.removeEventListener("mousedown", this.onMouseDown);
        this.eventDispatch.removeEventListener("dragstart", this.onDragStart);
        this.eventDispatch.removeEventListener("dragend", this.onDragEnd);
    };
    ListDragSourceBehavior.prototype.beginDrag = function (event) {
        var index = cellFromEvent(event).rowIndex;
        if (this.itemProvider && index >= 0) {
            var item = this.itemProvider.value[index];
            this.operation = beginDragOperation(event, {
                data: item,
                dropEffect: "none" /* none */,
                secondaryData: { index: index, sourceId: this.options.id },
                setDragImage: this.setDragImage,
                type: this.options.type
            });
        }
    };
    return ListDragSourceBehavior;
}());
export { ListDragSourceBehavior };
